import { render, staticRenderFns } from "./chatSet.vue?vue&type=template&id=5ed9ed55"
import script from "./chatSet.vue?vue&type=script&lang=js"
export * from "./chatSet.vue?vue&type=script&lang=js"
import style0 from "./chatSet.vue?vue&type=style&index=0&id=5ed9ed55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports